// extracted by mini-css-extract-plugin
export default {"messageBox":"EmbedPage_messageBox__PeQqr","animateSquiggles":"EmbedPage_animateSquiggles__a+nwa"};